import type {AppState} from "@stores/AppState";

import {ContextMenuProps} from "../../../elements/context-menu";
import {SelectOptionsAdditionalParams} from "./SelectOptions";


export const openSelectOptionsCtxMenu = (
    appState: AppState,
    targetElement: HTMLElement,
    params: SelectOptionsAdditionalParams,
    ctxMenuProps: {id: string} & Partial<ContextMenuProps>,
) => {

    const maxWidth = params.maxWidth ?? targetElement.getBoundingClientRect().width;

    appState.addAdditionalContextMenu({
        type: 'select-options',
        isDark: false,
        menuPlacement: 'block-end',
        menuAlignment: 'start',
        VERTICAL_SHIFT: 0,
        HORIZONTAL_SHIFT: 0,
        withPointer: false,
        withOverlay: !params.shouldForcePlace,
        shouldForcePlace: params.shouldForcePlace,
        getTargetBoundingBox: targetElement.getBoundingClientRect.bind(targetElement),
        params: {
            ...params,
        },
        minWidth: targetElement.getBoundingClientRect().width,
        maxWidth: maxWidth,
        ...ctxMenuProps,
    });
}

